const initialState = {
    refDataSourceConfigurations: [],
    defaultRefDataSourceConfigurations: [],
    sourceFieldsSettings: [],
    unMappedDataDictionaries: [],
    mappedDataDictionaries: [],
    refDataSourceConfig: {
        fieldName: '',
        fieldType: '',
        referenceId: '',
        active: '',
        deletedIndex: '',
    },
    fieldNames: [],
    selectedSourceConfigs: [],
    mappedDDForSelectionBox: [],
    gridRefDataSourceConfigurations: {
        fielddata: [
            {
                header: 'Ref Id',
                inputfield: false,
                length: 10,
                name: 'ref_id',
                placeholder: 'e.g. REF2020121212 ',
            },
            {
                header: 'Source Name',
                inputfield: true,
                length: 10,
                name: 'source_name',
                placeholder: '',
            },
            {
                header: 'description',
                inputfield: true,
                length: 10,
                name: 'source_desc',
                placeholder: '',
                dropdown: true,
            },
            {
                header: 'Active',
                inputfield: false,
                length: 1,
                name: 'active',
                placeholder: 'e.g. Y/N',
            },
            {
                header: 'Created date',
                inputfield: false,
                length: 1,
                name: 'created_date',
                placeholder: 'e.g Integer',
            },
            {
                header: 'Updated date',
                inputfield: false,
                length: 1,
                name: 'modified_date',
                placeholder: 'e.g Date',
            },
        ],
        instances: [],
    },

};

export default initialState;